import React from 'react';
import s from './ShareDrawer.module.scss';
import { ReactComponent as DownloadIcon } from 'images/new-icons/download.svg';
import { ReactComponent as NotInterestedIcon } from 'images/new-icons/not-interested.svg';
import { ReactComponent as ReportIcon } from 'images/new-icons/report-red.svg';
import { ReactComponent as CopyIcon } from 'images/new-icons/copied.svg';

const actionItems = [
  {
    // icon: <DownloadIcon />,
    text: 'Privacy Policy',
    action: 'privacy',
  },
  {
    // icon: <NotInterestedIcon />,
    text: 'Copyright',
    action: 'copyright',
  },
  {
    icon: <ReportIcon />,
    text: 'Report',
    action: 'report',
  },
];

const Actions = ({ downloadLink, isCopied }) => {
  const handleDownload = async link => {
    try {
      const response = await fetch(link);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = link.split('/').pop();
      document.body.appendChild(anchor);
      anchor.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(anchor);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return (
    <div className={s.actions}>
      <div className={s.actions_action_items}>
        {actionItems.map(item => (
          <div key={item.text} className={s.actions_action_item}>
            {item.action === 'report' && <div>{item.icon}</div>}
            <div>{item.text}</div>
          </div>
        ))}
      </div>
      {isCopied && (
        <div className={s.actions_action_copied}>
          <div>
            <CopyIcon />
          </div>
          <div>Copied</div>
        </div>
      )}
    </div>
  );
};

export default Actions;
